export default __webpack_public_path__ + "static/media/mTop_2_p4.b2cab809.jpeg";